import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.less';

const StatusBarGraph = ({ completed, errors, total, warnings }) => {
  if (total === 0) {
    return;
  }
  const completedMinusWarnings = completed - warnings; // warnings still complete
  const completedWidth = !completed ? 0 : (completedMinusWarnings / total) * 100;
  const warningWidth = !warnings ? 0 : (warnings / total) * 100;
  const errorWidth = !errors ? 0 : (errors / total) * 100;
  const hasGap = (completedWidth > 0 && warningWidth > 0) || (completedWidth > 0 && errorWidth > 0) || (errorWidth > 0 && warningWidth > 0);

  const graphStyle = {
    gridTemplateColumns: `${completedWidth}% ${warningWidth}% ${errorWidth}%`,
    gap: hasGap ? '1px' : '0',
  };

  return (
    <div className={style['status-bar-graph']} style={graphStyle}>
      <div className={style.completed} />
      <div className={style.warnings} />
      <div className={style.errors} />
    </div>
  );
};

StatusBarGraph.propTypes = {
  completed: PropTypes.number.isRequired,
  errors: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  warnings: PropTypes.number.isRequired,
};

export { StatusBarGraph };
